import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    SHOWNOTIFICATION = 'react/common/notification/SAVE',
}

export type Types = IBaseAction<Keys>;